export default "__VITE_ASSET__07035566__"